/* start - flights_split_bounds_us */
import { UIFlightSegment } from "@flights/types";
import React from "react";
import { useFlightCardLuggageWithCheckmarksController } from "./FlightCardLuggageWithCheckmarks/useFlightCardLuggageWithCheckmarksController";
import { getCampaignBadgesConfig } from "utils/flightCampaignConfig";
import { Stack } from "@bookingcom/bui-react";
import { useSplitBoundsCondition } from "utils/experiments/funnel/flights_split_bounds_us";

type Props = {
  segments: UIFlightSegment[];
  boundsVariant?: "outbound" | "inbound";
  campaignBadges: ReturnType<typeof getCampaignBadgesConfig>;
  luggageComponent?: React.ReactNode;
  badgesComponent?: React.ReactNode;
};

const CardSplitBoundsLuggageAndBadgesRendererDesktop = ({
  segments,
  boundsVariant,
  campaignBadges,
  luggageComponent,
  badgesComponent
}: Props) => {
  const { cabinBagText, personalBagText, checkedBagText } = useFlightCardLuggageWithCheckmarksController(segments);
  const { isSplitBounds } = useSplitBoundsCondition();

  const hasLuggage = !!cabinBagText || !!personalBagText || !!checkedBagText;
  const showLuggage = boundsVariant === "inbound" && hasLuggage;
  const showBadges = campaignBadges.length > 0;

  if (!showLuggage && !showBadges) {
    return null;
  }

  if (!isSplitBounds) {
    return null;
  }

  return (
    <Stack direction="row" gap={0} alignItems="center" mixin={{ marginBlockStart: 2 }}>
      {showLuggage && luggageComponent}
      {showBadges && badgesComponent}
    </Stack>
  );
};

export default CardSplitBoundsLuggageAndBadgesRendererDesktop;
/* end - flights_split_bounds_us */
